import React, { useRef } from 'react';
import axios from 'axios';

export const useHttpClient = (baseURL: string) => {
  const httpClient = useRef(
    axios.create({
      baseURL,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  );

  return httpClient.current;
};
